import { Container, Text } from '@melio/penny';
import { DeliveryMethod } from '@melio/platform-api';

import { useDeliveryMethodBannerText } from './useDeliveryMethodBannerText';

type DeliveryMethodInputProps = {
  deliveryMethod: DeliveryMethod | undefined;
  onChange: VoidFunction;
  loading?: boolean;
};

export const DeliveryMethodBanner = ({ deliveryMethod, onChange, loading = false }: DeliveryMethodInputProps) => {
  const deliveryMethodText = useDeliveryMethodBannerText({ deliveryMethod, onChange });

  return (
    <Container
      border="regular"
      paddingX="s"
      paddingY="xs"
      data-testid="delivery-method-banner"
      backgroundColor={loading ? 'light' : 'default'}
    >
      <div style={{ opacity: loading ? 0 : 1 }}>
        <Text textStyle="body3">{deliveryMethodText}</Text>
      </div>
    </Container>
  );
};
